import React from 'react';
import './CombinedHeadlines.css';

const CombinedHeadlines = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <div>
      {children.map((child, i) => {
        return (
          <div key={i} className="removeMarginChildren">
            {child}
          </div>
        );
      })}
    </div>
  );
};

export default CombinedHeadlines;
